var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F3F9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7753 28.2562C34.7753 30.5081 32.9436 32.337 30.6946 32.337H17.3062C15.0572 32.337 13.2253 30.5081 13.2253 28.2562V19.7374C13.2248 19.0116 13.4193 18.299 13.7883 17.6741L20.321 24.2068C21.2984 25.187 22.6072 25.7271 24.0017 25.7271C25.3935 25.7271 26.7023 25.187 27.6796 24.2068L34.2123 17.6741C34.5814 18.299 34.7758 19.0116 34.7753 19.7374V28.2562H34.7753ZM30.6945 15.6566H17.3062C16.3774 15.6566 15.5201 15.9709 14.8342 16.4939L21.4327 23.0952C22.1157 23.7753 23.0273 24.1525 24.0017 24.1525C24.9734 24.1525 25.885 23.7753 26.5679 23.0952L33.1664 16.4939C32.4806 15.9709 31.6233 15.6566 30.6945 15.6566ZM30.6945 14.082H17.3062C14.1884 14.082 11.6508 16.6197 11.6508 19.7374V28.2563C11.6508 31.3769 14.1884 33.9117 17.3062 33.9117H30.6945C33.8123 33.9117 36.3499 31.3769 36.3499 28.2563V19.7374C36.3499 16.6196 33.8123 14.082 30.6945 14.082Z",
    fill: "#10778C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.1a73aa19f195dd7a9e82fceef915b0e6.svg";
export { ForwardRef as ReactComponent };